/* eslint-disable linebreak-style */
/* IntelApps — Home: Selected work slider */
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { PROJECTS } from './Portfolio.js';
import { useI18n } from '../i18n.js';

export default function HomeWorkSlider() {
  const { t } = useI18n();
  const projects = useMemo(() => PROJECTS.slice(0, 3), []);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % projects.length);
    }, 6000);
    return () => clearInterval(id);
  }, [projects.length]);

  const p = projects[idx];

  return (
    <section className="section" id="work">
      <div className="container">
        <div className="section-head">
          <div>
            <span className="eyebrow">{t.portfolio.eyebrow}</span>
            <h2>{t.portfolio.title}</h2>
          </div>
          <p>{t.portfolio.description}</p>
        </div>

        <div className="home-work-slider">
          <div className="home-work-slider-grid">
            <div className="home-work-slider-details">
              <span className="home-work-tag">{p.tag}</span>
              <h3 className="home-work-title">{p.title}</h3>
              <p className="home-work-meta">{p.meta}</p>
              {p.result && <div className="home-work-result">{p.result}</div>}

              <div className="home-work-actions">
                <Link to={`/work/${p.id}`} className="btn btn-accent">
                  View case study
                </Link>
                <Link to="/work" className="btn btn-ghost">
                  View all work
                </Link>
              </div>

              <div className="home-work-dots" role="tablist" aria-label="Selected work">
                {projects.map((x, i) => (
                  <button
                    key={x.id}
                    type="button"
                    className={`home-work-dot ${i === idx ? 'active' : ''}`}
                    onClick={() => setIdx(i)}
                    aria-label={`Show ${x.title}`}
                    aria-pressed={i === idx}
                  />
                ))}
              </div>
            </div>

            <div className="home-work-slider-media">
              <Link
                to={`/work/${p.id}`}
                className="home-work-media-link"
                aria-label={`Open ${p.title}`}
              >
                <img src={p.img} alt={p.title} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
